import script from "./EmptyStateDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyStateDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EmptyStateDashboard.vue?vue&type=style&index=0&id=39e9bbdd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e9bbdd"]])

export default __exports__